import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import apiRequest from "../../../functions/api";
import {
  Paper,
  TextField,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import BetragInput from "../../shared/components/BetragInput";
import Grid from "@mui/material/Grid";
import { useMessage } from "../../../context/message-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { responsiveFontSizes, useTheme } from "@mui/material/styles";
import openFile from "../../shared/functions/download";
import CloseIcon from "@mui/icons-material/Close";
import NewExpense from "../NewExpense";
import ExpenseMobileTable from "../ExpenseMobileTable";
import ExpenseTable from "../ExpenseTable";
import { getFile } from "../getFile";
import EditAusgabe from "./EditAusgabe";
import ExpenseCard from "./ExpenseCard";
import AddIcon from "@mui/icons-material/Add";
import { Fragment } from "react";
function Bankverbindung(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { accessToken, client, element, program, ChangeFiles, lock, files, formular, formularkey } = props;
  const { showErrorMessage } = useMessage();
  const [ibaneingabe, setIbaneingabe] = useState("");
  const [bank, setBank] = useState("");
  const [bic, setBic] = useState("");
  const [autoBic, setAutoBic] = useState("");
  const [autoBank, setAutoBank] = useState("");
  const [kontonummer, setKontonummer] = useState("");
  const [blz, setBLZ] = useState("");
  const [ibanError, setIbanError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [abwkontoinh, setAbwKontoInh] = useState("");

  const init = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BANKVERBINDUNG_INIT",
      formular: formular,
    };
    apiRequest("POST", "daten", payload, headers, initCB, setRedirect);
  };
  const initCB = (response) => {
    if (response.data.daten) {
      setIbaneingabe(response.data?.iban);
      setBank(response.data?.bank);
      setAutoBank(response.data?.bank);
      setBic(response.data?.bic);
      setAutoBic(response.data?.bic);
      setBLZ(response.data?.blz);
      setAbwKontoInh(response.data?.abwkontoinh);
    }
    // setAufwendungen(response.data.aufwendungen)
    // setKostenstellenOptionen(response.data.kostenstellen);
    // setStaaten(response.data.staaten);
    // setArtikelOptionen(response.data.artikelOptionen);
    // setCurrencies(response.data.waehrungen);
  };
  const setRedirect = (path) => {
    navigate(path);
  };

  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
      signal: controller.current.signal,
    });
  };

  const [bankverbindung, setBankverbindung] = useState({
    IBAN: "",
    BIC: "",
    EMPFAENGER: "",
  });

  // const WertChange = (was, wert) => {
  //   const zwis = bankverbindung;
  //   zwis[was] = wert;
  //   setBankverbindung(...zwis);
  // };
  const WertChange = (field, value) => {
    setBankverbindung((prevBankverbindung) => ({ ...prevBankverbindung, [field]: value }));
  };
  const prevElementRef = useRef(null);
  const prevObjectRef = useRef(null);
  
  useEffect(() => {
    if (formularkey === "neu") {
      init();
    }
  }, []);

  useEffect(() => {
    if (prevElementRef.current !== element.felderAntworten) {
      if (program !== "FORGEN") {
        setIbaneingabe(element?.felderAntworten?.iban);
        setBank(element?.felderAntworten?.bank);
        setAutoBank(element?.felderAntworten?.bank);
        setBic(element?.felderAntworten?.bic);
        setAutoBic(element?.felderAntworten?.bic);
        setBLZ(element?.felderAntworten?.blz);
        setAbwKontoInh(element?.felderAntworten?.abwkontoinh);
      }
      prevElementRef.current = element.felderAntworten;
    }
  }, [element, program]);

  useEffect(() => {
    const object = { ibaneingabe, bank, bic, blz, abwkontoinh };
    if (JSON.stringify(prevObjectRef.current) !== JSON.stringify(object)) {
      if (program !== "PMURA3") {
        let summe = 0;
        let sammelFelder = [];
        element.summe = "1";
        element.felderAntworten = { iban: ibaneingabe, bank: bank, bic, bic, blz: blz, abwkontoinh: abwkontoinh };
        props.onChange(element.key, element, undefined);
      }
      prevObjectRef.current = object;
    }
  }, [ibaneingabe, bank, bic, blz, abwkontoinh]);

  const pruefeiban = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORMUL",
      statement: "IBAN_PRUEFEN",
      iban: ibaneingabe,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, pruefcb, errorCb);
  };
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung"));
  };
  const ibanGeaendert = (neueIban) => {
    var formattedIban = neueIban.replace(/[^\w\s]/gi, "").replace(" ", "");

    if (formattedIban.length <= 34) {
      // setBankverbindung({
      //   IBAN: formattedIban,
      //   BIC: "",
      //   EMPFAENGER: "",
      // });
      setIbaneingabe(formattedIban);
    }
    setBank("");
    setBic("");
    setBLZ("");
    setKontonummer("");
  };
  const pruefcb = (response) => {
    if (response.status === 200) {
      if (response.data.message === "ok") {
        setIbanError("");
        setBank(response.data.bankname);
        setAutoBank(response.data.bankname);
        setBic(response.data.bic);
        setAutoBic(response.data.bic);
        setBLZ(response.data.blz);
        setKontonummer(response.data.kontonummer);
      } else {
        setIbanError(response.data.message);
        showErrorMessage(response.data.message);
        setBank("");
        setAutoBank("");
        setBic("");
        setAutoBic("");
        setBLZ("");
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindungs"));
      }
    }
  };
  const handleBankChange = ({ target: { value } }) => {
    setBank(value);
  };
  const handleBicChange = ({ target: { value } }) => {
    setBic(value);
  };
  const updateElement = () => {
    let summe = 0;
    let sammelFelder = [];

    element.summe = "1";
    console.log({ iban: ibaneingabe, bank: bank, bic, bic });
    element.felderAntworten = { iban: ibaneingabe, bank: bank, bic: bic };
    props.onChange(element.key, element, undefined);
  };
  return (
    <>
      <Fragment>
        <Grid item xs={12} md={4}>
          <Typography
            align="left"
            // style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
          >
            IBAN
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <TextField
            id="iban"
            // label={t("Neue IBAN")}
            disabled={lock}
            variant="outlined"
            value={ibaneingabe}
            error={ibanError !== ""}
            onBlur={() => {
              if (bank === "" || bic === "") pruefeiban();
            }}
            onKeyUp={(e) => {
              if (e.code === "Enter") pruefeiban();
            }}
            helperText={ibanError}
            onChange={(event) => {
              ibanGeaendert(event.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />

          {/* <TextField
            // label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort ? "" : item.inhalt}
            size="small"
            fullWidth
            disabled={lock}
            value={bankverbindung?.IBAN ?? ""}
            onChange={(e) => WertChange("IBAN", e.target.value)}
            // InputLabelProps={item.inhalt ? { shrink: false } : {}}
          /> */}
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            align="left"
            // style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
          >
            Bankname
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <TextField
            variant="outlined"
            // label={t("Bankname")}
            value={bank}
            onChange={handleBankChange}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            disabled={autoBank !== ""}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            align="left"
            // style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
          >
            BIC
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <TextField
            variant="outlined"
            // label={t("BIC")}
            value={bic}
            onChange={handleBicChange}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            disabled={autoBic !== ""}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            align="left"
            // style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
          >
            Abweichender Kontoinhaber
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} align="left">
          <TextField
            variant="outlined"
            label={t("Abweichender Kontoinhaber")}
            helperText="*nur angeben, wenn Sie nicht der Kontoinhaber sind"
            value={abwkontoinh}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={lock}
            onChange={(event) => {
              setAbwKontoInh(event.target.value);
            }}
            fullWidth
          />
          {/* <TextField
            // label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort ? "" : item.inhalt}
            size="small"
            fullWidth
            disabled={lock}
            value={bankverbindung?.EMFPAENGER ?? ""}
            onChange={(e) => WertChange("EMFPAENGER", e.target.value)}
            // value={item.antwort ? item.antwort : ""}
            // onChange={(e) => ValidateWertChange(item.key, -1, e.target.value, item.typ, item.limit)}
            // InputLabelProps={item.inhalt ? { shrink: false } : {}}
          /> */}
        </Grid>
      </Fragment>

      {/* </Grid> */}
    </>
  );
}

export default Bankverbindung;
